import React, {Component} from 'react';
import {Button, Col, Image, OverlayTrigger, Row, DropdownButton, MenuItem} from 'react-bootstrap';
import {SketchPicker} from 'react-color';
import Colour_Picker from '../../components/Colour_Picker';
import reactCSS from 'reactcss';
import ManateeDropdown from '../../components/ManateeDropdown';
import tooltips from '../../components/Tooltips';

class ImageOptionsPanel extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            icon_colorpicker_display: [],
            bulk_edit_label_temp: "",
            bulk_edit_open: false
        }
    }

    
    handleLabelChange = (e) => {
        this.setState({bulk_edit_label_temp: e.target.value});
    }

    handleSpaceBar = (e) => {
        if(e.key == " "){
            e.preventDefault();
            e.stopPropagation();
            this.setState({bulk_edit_label_temp: this.state.bulk_edit_label_temp + " "});
        }
    }

    get_current_label = () => {
        if(this.props.design_selection && this.props.design_selection.user_labels && this.props.design_selection.user_labels["image"]){
            var label_id = this.props.design_selection.user_labels["image"];
            var label_find = window.design_editor.design.bulk_edit_data.labels.find(o => {return o.id == label_id})
            if(label_find){
                return label_find.text
            }
        }
        return "";
    }

    bulk_edit_on_click = async () => {
        if(this.get_current_label() == "" && this.state.bulk_edit_label_temp != ""){
            if(this.props.design_selection && this.props.design_selection.user_labels && this.props.design_selection.user_labels["image"]!=undefined){
                var new_label_id = window.utils.uuidv4()
                window.design_editor.design.bulk_edit_data.labels.push({
                    id: new_label_id, text: this.state.bulk_edit_label_temp, assigned: [this.props.design_selection.id], selected: true, type: 'image'
                });
                
                this.props.design_selection.user_labels["image"] = new_label_id;
                window.design_editor.addUndoChange()
            }
            this.setState({});
        }

        await this.props.switch_nav_tab("");
        await this.props.switch_nav_tab("bulk_edit");
    }

    bulk_edit_toggle = (isOpen, e) => {
        if(e.target.type != 'text'){
            this.setState({bulk_edit_open:isOpen})
        }
    }

    componentDidMount() {
        this.setState({bulk_edit_label_temp:""});
    }


    componentWillUnmount() {
        
    }

    handleClickIconColorPicker = (e) => {
        var index = e.target.getAttribute('icon_cp_index');
        var icon_colorpicker_display = this.state.icon_colorpicker_display

        icon_colorpicker_display[index] = !icon_colorpicker_display[index]
        this.setState({ icon_colorpicker_display })
    };
    
    handleCloseIconColorPicker = (e) => {
        var index = e.target.getAttribute('icon_cp_index');
        var icon_colorpicker_display = this.state.icon_colorpicker_display
        icon_colorpicker_display[index] = false
        
        this.setState({ icon_colorpicker_display })
    };

    IconColorPickers = () => {
        var result = []
        if(this.props.design_selection&&this.props.design_selection.sub_type == 'icon'){
            var svg_colors = this.props.design_selection.image_details.svg_colors
            for (let i = 0; i < svg_colors.length; i++) {
                if(i==5){
                    continue;
                }
                var styles = reactCSS({
                    'default': {
                      color: {
                        width: '30px',
                        height: '30px',
                        borderRadius: '15px',
                        'border': '1px',
                        backgroundColor: svg_colors[i].color?svg_colors[i].color:'#000000',
                      },
                      swatch: {
                        padding: '2.5px',
                        borderRadius: '15px',
                        display: 'inline-block',
                        cursor: 'pointer',
                      },
                      popover: {
                        position: 'absolute',
                        zIndex: '2',
                      },
                      cover: {
                        position: 'fixed',
                        top: '0px',
                        right: '0px',
                        bottom: '0px',
                        left: '0px',
                        zIndex: '-1'
                      },
                    },
                });

                var resource_thumbnail = (
                    <div key={i} style={{marginLeft:'5px'}}>
                        <div icon_cp_index={i} style={ styles.swatch } onClick={ this.handleClickIconColorPicker }>
                        <div icon_cp_index={i} style={ styles.color } />
                        </div>
                        { this.state.icon_colorpicker_display[i] ? <div style={ styles.popover }>
                        <div icon_cp_index={i} style={ styles.cover } onClick={ this.handleCloseIconColorPicker }/>
                        <Colour_Picker user={this.props.user}  presetColors={['#ffffff','#f3ec3a','#f9bd17','#f99b1d','#f15523','#ef3124','#DE0081','#a71e48','#7c3597','#463191','#000000','#3d5dac','#1296ce','#63b145','#19BC81','#d0dd36']} disableAlpha={true} color={styles.color.backgroundColor} onChange={ (e) => {this.props.update_inputs_image(e,'svg_color_'+i) }} />
                        </div> : null }
                    </div>
                );
                result.push(resource_thumbnail)
            }
        }
        return result;
    }

    Dropdown_trigger = ({ toggle_dropdown }) => (
        <Button className="btn-toolbar" onClick={() => toggle_dropdown()} style={{ 'marginRight': '5px', outline: 'none', cursor: 'pointer' }}>
            <Image style={{ height: 20 }} src={global.config.static_file_server_path + 'uploads/icons/flip_vertically.svg'} />
        </Button>
    )

    Dropdown_dropper = () => (
        <ul className="toolbar-dropdown">
            <li className="toolbar-dropdown-item" onClick={(e) => {this.props.update_inputs_image(e,'flip_horizontal')}}>
                <Image style={{ height: 20 }} src={global.config.static_file_server_path + 'uploads/icons/flip_horizontally.svg'} />
                <span className="toolbar-dropdown-text">Flip Horizontal</span>
            </li>
            <li className="toolbar-dropdown-item" onClick={(e) => {this.props.update_inputs_image(e,'flip_vertical')}}>
                <Image style={{ height: 20 }} src={global.config.static_file_server_path + 'uploads/icons/flip_vertically.svg'} />
                <span className="toolbar-dropdown-text">Flip Vertical</span>
            </li>
        </ul>
    )
    
    Enhance_Dropdown_trigger = ({ toggle_dropdown }) => (
        <Button className="btn-toolbar" onClick={() => toggle_dropdown()} style={{ 'marginRight': '5px', outline: 'none', cursor: 'pointer' }}>
            <Image style={{ height: 20 }} src={global.config.static_file_server_path + 'uploads/icons/image_enhance.svg'} />
        </Button>
    )

    Enhance_Dropdown_dropper = () => (
        <ul className="toolbar-dropdown">
            <li className="toolbar-dropdown-item" onClick={(e) => {this.props.switch_nav_tab('filters')}}>
                <Image style={{ height: 20 }} src={global.config.static_file_server_path + 'uploads/icons/image_filter.svg'} />
                <span className="toolbar-dropdown-text">Filter                               </span>
            </li>
            <li className="toolbar-dropdown-item" onClick={this.props.adjustmentPanelOnclick}>
                <Image style={{ height: 20 }} src={global.config.static_file_server_path + 'uploads/icons/image_brightnesscontrast.svg'} />
                <span className="toolbar-dropdown-text">Adjustment</span>
            </li>
            <li className="toolbar-dropdown-item" onClick={this.props.shadowsPanelOnClick}>
                <span className="toolbar-dropdown-text">Shadows</span>
            </li>
            {/*<li className="toolbar-dropdown-item" onClick={this.props.backgroundRemovalPanelOnclick}>
                <Image style={{ height: 20 }} src={global.config.static_file_server_path + 'uploads/icons/image_bg_remove.svg'} />
                <span className="toolbar-dropdown-text">Remove Background</span>
            </li>*/}
            {/*this.props.design_selection&&this.props.design_selection.sub_type == 'mockup'?(<li className="toolbar-dropdown-item" onClick={this.props.mockupEditorPanelOnclick}>
                <Image style={{ height: 20 }} src={global.config.static_file_server_path + 'uploads/icons/Mockup.svg'} />
                <span className="toolbar-dropdown-text">Edit Mockup</span>
            </li>):''*/}
        </ul>
    )              
    
    render() {
        return (
            <Row className="d-flex align-items-center" style={{padding: 5, backgroundColor: '#F1F2F3', zIndex :1010}}>
                <Col xs={6} style={{'display':'flex','flexFlow':'row',paddingRight:'0',zIndex:"10000"}}>
                    {this.props.design_selection&&this.props.design_selection.sub_type == 'mockup'?(
                        <OverlayTrigger delayShow={400} placement="bottom" overlay={tooltips['edit_mockup']}>
                            <Button className="btn-toolbar" onClick={this.props.mockupEditorPanelOnclick} style={{ 'marginRight': '5px', outline: 'none', cursor: 'pointer' }}>
                                <Image style={{ height: 20 }} src={global.config.static_file_server_path + 'uploads/icons/Mockup.svg'} />
                            </Button>
                        </OverlayTrigger>
                    ):''}
                    <OverlayTrigger delayShow={400} placement="bottom" overlay={tooltips['photo_editor']}><div>
                        <ManateeDropdown 
                            Trigger={this.Enhance_Dropdown_trigger}
                            Dropper={this.Enhance_Dropdown_dropper}
                        />
                    </div></OverlayTrigger>
                    <OverlayTrigger delayShow={400} placement="bottom" overlay={tooltips['crop']}>
                        <Button className="btn-toolbar" onClick={this.props.enter_crop_mode} style={{ 'marginRight': '5px', outline: 'none', cursor: 'pointer' }}>
                            <Image style={{ height: 20 }} src={global.config.static_file_server_path + 'uploads/icons/crop_temp.svg'} />
                        </Button>
                    </OverlayTrigger>
                    <OverlayTrigger delayShow={400} placement="bottom" overlay={tooltips['flip']}><div>
                        <ManateeDropdown 
                            Trigger={this.Dropdown_trigger}
                            Dropper={this.Dropdown_dropper}
                        />
                    </div></OverlayTrigger>
                    <OverlayTrigger delayShow={400} placement="bottom" overlay={tooltips['bg_removal']}>
                        <Button className="btn-toolbar" onClick={this.props.toggle_background_removal} style={{ 'marginRight': '5px', outline: 'none', cursor: 'pointer' }}>
                            <Image style={{ height: 20 }} src={this.props.design_selection&&this.props.design_selection.bgremoval.enabled?global.config.static_file_server_path + 'uploads/icons/image_bg_remove_cancel.svg':global.config.static_file_server_path + 'uploads/icons/image_bg_remove.svg'} />
                        </Button>
                    </OverlayTrigger>
                    {global.config.application_env != "" && (<OverlayTrigger delayShow={400} placement="bottom" overlay={tooltips['animate']}>
                        <Button className="btn-toolbar" onClick={() => this.props.animateOnClick("element")} style={{ 'marginRight': '5px', outline: 'none', cursor: 'pointer' }}>
                            <Image style={{ height: 20 }} src={null} />
                            Animate
                        </Button>
                    </OverlayTrigger>)}
                    <this.IconColorPickers/>
                    <DropdownButton
                        pullLeft={true}
                        className="btn-toolbar" 
                        style={{'marginRight': '5px'}}                    
                        title="Bulk Label"
                        open={this.state.bulk_edit_open}
                        onToggle={this.bulk_edit_toggle}
                        >
                            <MenuItem className="disable-hover-bg" style={{paddingTop:"10px",paddingBottom:"10px",width:'300px'}} draggable="false">
                                <Row>
                                    <Col xs={2}>
                                        <Image style={{ height: 30, float:"right"}} src={global.config.static_file_server_path + 'uploads/icons/Photos.svg'} />
                                    </Col>
                                    <Col xs={10} style={{paddingLeft:0, paddingRight:0}}>
                                        {/* <InputGroup style={{border: "1px solid grey",width:"100%"}}> */}
                                            {this.get_current_label()==""?(<input
                                                key={"create_new_label"}
                                                value={this.state.bulk_edit_label_temp}
                                                style={{border: "1px solid grey",width:"100%",fontSize: 14, fontFamily: 'Montserrat', height: 30, borderRadius: 0}}
                                                placeholder={'Enter a label'}
                                                type="text"
                                                onKeyUp={(e) => this.handleSpaceBar(e)}
                                                onChange={(e) => this.handleLabelChange(e)}
                                            />):(<input
                                                key={"manage_labels"}
                                                style={{border: "1px solid grey",width:"100%",fontSize: 14, fontFamily: 'Montserrat', height: 30, borderRadius: 0}}
                                                placeholder={'Manage Labels'}
                                                value={this.get_current_label()}
                                                type="text"
                                                disabled={true}
                                                // onChange={(e) => handleChange(id, e)}
                                            />)}
                                        {/* </InputGroup> */}
                                    </Col>
                                </Row>
                            </MenuItem>
                            <MenuItem className="disable-hover-bg" style={{display:"flex",justifyContent:"center",paddingTop:"10px",paddingBottom:"10px"}} draggable="false">
                                <Button onClick={this.bulk_edit_on_click} className="btn btn-sm btn-block btn-orange" style={{textAlign: 'center'}}>{this.get_current_label()!=""?"Manage Labels":" OK "}</Button>
                            </MenuItem>
                    </DropdownButton>
                </Col>
                {this.props._rhs_options_panel()}
            </Row>
        );
    }
}

export default ImageOptionsPanel;